@if (isInline() || isRadioInline()) {
  <ng-container *ngTemplateOutlet="content"></ng-container>
} @else {
  <div cdkOverlayOrigin #trigger="cdkOverlayOrigin" (click)="toggle()">
    @if (!hidden()) {
      @if (!button.childElementCount) {
        <shared-ui-button
          type="button"
          mode="outline"
          [buttonClass]="buttonClass()"
          [disabled]="isDisabled()"
          [focus]="isOpen()"
          utility="dropdown"
          size="small"
        >
          @if (title()) {
            <div class="flex">
              <span>{{ title() }}</span>

              @if (extraTitle()) {
                <shared-ui-badge
                  class="ml-[8px]"
                  [text]="extraTitle()"
                ></shared-ui-badge>
              }
            </div>
          } @else {
            <span class="text-base-500">{{ placeholder() }}</span>
          }
        </shared-ui-button>
      }
      <div #button><ng-content select="[button]"></ng-content></div>
    }
  </div>

  <ng-template
    #menu
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOpen()"
    [cdkConnectedOverlayHasBackdrop]="true"
    (backdropClick)="close()"
    (detach)="close()"
    [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
    (overlayOutsideClick)="close()"
  >
    <div class="menu {{ menuClass() }}" [@openClose]="false">
      <ng-container *ngTemplateOutlet="header"></ng-container>

      <ng-scrollbar
        [autoHeightDisabled]="false"
        [autoWidthDisabled]="false"
        appearance="standard"
        track="all"
        pointerEventsMethod="scrollbar"
        [style.max-height.px]="maxHeight()"
        [style.height.px]="height()"
      >
        <div (click)="onContentClick()">
          <ng-container *ngTemplateOutlet="content"></ng-container>
        </div>
      </ng-scrollbar>

      <ng-container *ngTemplateOutlet="footer"></ng-container>
    </div>
  </ng-template>
}

<ng-template #content>
  <ng-content></ng-content>
</ng-template>

<ng-template #header>
  <ng-content select="[header]"></ng-content>
</ng-template>

<ng-template #footer>
  <ng-content select="[footer]"></ng-content>
</ng-template>
